import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy page — previously showed "Download the App" screen.
 * Now redirects to student landing since web features are available.
 */
export default function DraftInviteSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/student-landing', { replace: true });
  }, [navigate]);

  return null;
}

